export default __webpack_public_path__ + "static/media/pic10.6c0595dd.jpg";